import { render } from "./TabsTrigger.vue?vue&type=template&id=a6e632c2&ts=true"
import script from "./TabsTrigger.vue?vue&type=script&setup=true&lang=ts"
export * from "./TabsTrigger.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/tabs/TabsTrigger.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a6e632c2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a6e632c2', __exports__)) {
    api.reload('a6e632c2', __exports__)
  }
  
  module.hot.accept("./TabsTrigger.vue?vue&type=template&id=a6e632c2&ts=true", () => {
    api.rerender('a6e632c2', render)
  })

}


export default __exports__